import api from './api'
import os from '@edu-fe/os'
import assign from 'lodash.assign'
import Pay from '@edu-fe/pay'
import login from '@/utils/login'

import { isxxx } from '@mixins/isxxx'

const {
  isWpsAndroid,
  isWpsIos,
  isAppAndroid,
  isAppIos
} = isxxx

class Sign {
  constructor () {
    this.state = {
      userName: '',
      userPic: '',
      signStatus: 0,
      cardList: [],
      bonus: 0,
      courses: [],
      isBuy: 0,
      endDate: 0,
      isFilterMonthVip: 0,
      paying: false
    }
  }

  setVal (data) {
    assign(this.state, data)
  }

  /**
   * 获取畅学卡信息
   * **/
  async getPrivilegeDetail () {
    const { data } = await api.privilege.getPrivilegeDetail()
    const { userName, userPic, signStatus, list, isBuy, endDate, isFilterMonthVip } = data
    // 对卡名称做处理
    list.map((val) => {
      if (val.type === 1 && signStatus !== 2) {
        val.title = '连续包月'
      }
      if ((val.type === 1 && signStatus === 2) || (os.type !== 'weixin' || isAppIos)) {
        val.title = '购买月卡'
      }
      if (val.type === 2) {
        val.title = '年会员'
      }
    })
    let cardList = list.sort((a, b) => {
      return a.type - b.type
    })
    this.setVal({ userName, userPic, signStatus, isBuy, endDate, cardList, isFilterMonthVip })
  }
  /*
  * 签约逻辑
  * @param {Object}   params 参数
  * @param {Number}   params.cardType 必须 1为购买月卡 其他为购买年卡
  * @param {String}   params.courseId 畅学卡ID
  * @param {String}   params.finalPayPrice 畅学卡价格
  * @param {String}   params.title 畅学卡名称， 用于才博APP
  * @param {String}   params.from 渠道
  **/
  async sign ({ cardType, courseId, finalPayPrice, title, from }) {
    if (cardType === 1 && this.signStatus !== 2 && isAppAndroid) {
      os.sdk.pay.sign({
        courseId: courseId,
        price: finalPayPrice,
        title: title,
        imageUrl: 'http://edu-wps.ks3-cn-beijing.ksyun.com/images/%E7%95%85%E5%AD%A6%E5%8D%A1.png'
      })
      return true
    }
    if (cardType === 1 && this.signStatus !== 2 && (os.type === 'weixin' || isWpsAndroid)) {
      const { data } = await api.privilege.signWX(from)()
      if (isWpsAndroid) {
        os.sdk.pay.call({
          pay_title: '',
          pay_sum: 19.00,
          pay_body: '',
          pay_trade_no: '',
          pay_way: 'wxpay_android',
          pay_notify_url_wx: '',
          pay_notify_url_ali: '',
          pay_local: true,
          auto_pay_url: data
        })
      } else {
        window.location.href = data
      }
      return true
    } else {
      return false
    }
  }
  /*
  * 支付逻辑
  * @param {Object}   params 参数
  * @param {String}   params.courseId 必须 畅学卡ID
  * @param {String}   params.from 渠道
  * @param {Number}   params.finalPayPrice 必须 畅学卡价格
  * @param {Boolean}  params.active 是否使用奖励金
  * @param {Function}  params.emit 购买完成回调
  * @param {Function}  params.emit 购买完成回调
  **/
  async pay ({ courseId, finalPayPrice, from, active, emit, goto }) {
    const wpsSid = await login.getWpsSid()
    if (!wpsSid) {
      return login.login()
    }
    if (this.paying) return console.log('正在支付...')
    this.paying = true
    if (isAppAndroid || isAppIos) {
      this.paying = false
      os.sdk.pay.call({
        goodId: courseId,
        goodType: 8
      })
      return true
    }
    /* eslint-disable */
    new Pay({
      courseId: courseId,
      type: 8,
      from,
      price: finalPayPrice,
      // payment: true,
      isSend: 1, // 将payment改为isSend, 用于阻止支付模块查看课程是否已购买, 后台无影响, 畅学卡买了就是自己的
      payWay: isWpsIos ? undefined : '10', // 资源券, 10:微信
      usedReward: active ? 1 : 0,
      loginCallback: wpsSid => {
        this.paying = false
        if (!this.state.isFilterMonthVip) {
          emit()
        }
      },
      gotoResult: orderId => {
        this.paying = false
        window.location.reload()
        emit()
      },
      gotoPayment: () => {
        this.paying = false
        goto()
        if (!this.state.isFilterMonthVip) {
          emit()
        }
      },
      failCallback: () => {
        this.paying = false
        if (!this.state.isFilterMonthVip) {
          emit()
        }
      },
      cancelCallback: () => {
        this.paying = false
        if (!this.state.isFilterMonthVip) {
          emit()
        }
      }
    })
  }
}

export default new Sign()
